import request from "@Utils/api";
import api from "@Configs/apiConfig";
import base64 from "base64-js";

function authenticate(username, password) {
  const token = base64.fromByteArray( new TextEncoder().encode(username + ":" + password));

  return request({
    url: api.loginServer + "/login",
    // url: api.loginServer + '/login.json',
    method: "POST",
    // method: 'GET',
    data: token,
    headers: {
      "Content-Type": "text/plain",
    },
  });
}

function getImpersonationToken(targetUserMail) {
  return request({
    url: api.loginServer + "/impersonate",
    method: "POST",
    data: { impersonationTarget: targetUserMail },
    headers: {
      "x-access-token": localStorage.getItem("Token"),
    },
  });
}

function authenticateSSO(id,token){
  return request({
    url: api.loginServer + "/sso",
    method: "POST",
    data: JSON.stringify({ id, token }),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

const Login = {
  authenticate,
  getImpersonationToken,
  authenticateSSO,
};

export default Login;
